/**
 * Constants for Xpert Learning Assistant Plugin
 *
 */

export const VERIFIED_MODES = ['verified', 'credit', 'professional', 'no-id-professional'];

export const ALLOW_UPSELL_MODES = ['audit', 'honor'];
